import * as React from 'react';
/**
 *
 * Original name: stamp
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A311
 *
 */
export const StampPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "M56 52H8v4h48v-4ZM46 32h-7v-2.066a5.964 5.964 0 0 1 2.821-5.088L43 24.107V19c0-6.579-4.421-11-11-11s-11 4.421-11 11v5.107l1.18.739A5.963 5.963 0 0 1 25 29.934V32h-7A10.011 10.011 0 0 0 8 42v6h48v-6a10.013 10.013 0 0 0-10-10Zm6 12H12v-2a6.007 6.007 0 0 1 6-6h11v-6.066a9.938 9.938 0 0 0-4-8V19c0-4.317 2.682-7 7-7s7 2.683 7 7v2.934a9.933 9.933 0 0 0-4 8V36h11a6.007 6.007 0 0 1 6 6v2Z", fill: "currentColor" })));
